import { QuestionType } from '@repo/types/enums/questionType';
import { infer as Infer, z } from 'zod';

export const questionBaseSchema = z.object({
  id: z.uuid(),
  type: z.enum(QuestionType),
  content: z.string().min(1, 'Opis pytania jest wymagany').max(2048),
  points: z.number('Punkty są wymagane').positive('Punkty muszą być liczbą dodatnią'),
});

export type QuestionBaseSchema = Infer<typeof questionBaseSchema>;
